export default __webpack_public_path__ + "static/media/analog_bjt.3006a57c.svg";